import { render, staticRenderFns } from "./CancelledBookings.vue?vue&type=template&id=7a636cec"
import script from "./CancelledBookings.vue?vue&type=script&lang=js"
export * from "./CancelledBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports